// Tree status color helper.
// Use this inside ActivityTreePanel card/chip styling.

export const planningNodeStatus = (node: any) => {
  const missingCount = Number(node.missingcount || 0);
  const taskCount = Number(node.taskcount || 0);
  const budgetCount = Number(node.budgetlinecount || 0);
  const planCount = Number(node.activityplancount || 0);

  if (missingCount > 0) return 'error';
  if (node.nodetype === 'ACTIVITY' && (taskCount === 0 || planCount === 0)) return 'warning';
  if (node.nodetype === 'TASK' && budgetCount === 0) return 'info';
  return 'success';
};

export const planningNodeSx = (node: any, selected: boolean) => {
  const status = planningNodeStatus(node);

  const colors: any = {
    success: { borderColor: '#2e7d32', bgcolor: selected ? '#e8f5e9' : '#ffffff' },
    warning: { borderColor: '#ed6c02', bgcolor: selected ? '#fff4e5' : '#ffffff' },
    error: { borderColor: '#d32f2f', bgcolor: selected ? '#fdecea' : '#ffffff' },
    info: { borderColor: '#0288d1', bgcolor: selected ? '#e5f6fd' : '#ffffff' },
  };

  return {
    borderLeft: '5px solid',
    ...colors[status],
  };
};

// Example use:
// <Card sx={{ mb: 1, cursor: 'pointer', ...planningNodeSx(node, selectedNid === node.nid) }}>
